<template>
    <div class="card card-dark border-dark mb-4">
        <div class="card-body">
            <div class="row text-center text-lg-left">
                <div v-for="item in items" class="col-lg-3 col-md-4 col-xs-6">
                    <a :href="item.orig" class="d-block mb-4 h-100"
                       data-toggle="lightbox"
                       data-gallery="photo-gallery"
                       :data-footer="item.capt">
                        <img class="img-fluid img-thumbnail"
                             :src="item.thumb"
                             :alt="item.capt">
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import 'ekko-lightbox'

    export default {
        data() {
            return {
                items: []
            }
        },
        created() {
            this.loadItems()
        },
        mounted() {
            const photoGallery = this;
            const translateFilter = Vue.filter('translate');

            $(this.$el).on('click', '[data-toggle="lightbox"]', function (event) {
                event.preventDefault();

                // Open modal.
                $(this).ekkoLightbox({
                    onShown: function () {
                        const title = translateFilter('photo.download');
                        const saveButton = $('<i class="fa fa-save ekko-lightbox-item__save-btn" title="' + title + '"></i>');
                        this._$lightboxContainer.append(saveButton);
                        saveButton.click(e => {
                            e.stopPropagation();

                            // Download the photo file.
                            const photoId = photoGallery.items[this._galleryIndex].id;
                            window.open(
                                window.location.protocol + "//" + window.location.host
                                + '/api/download/photo/' + photoId,
                                '_blank'
                            );
                        });
                    }
                });
            })
        },
        methods: {
            loadItems() {
                axios.get('/api/photo')
                    .then(response => this.items = response.data.data)
                    .catch(error => console.error(error))
            }
        }
    }
</script>

<style lang="scss">
    @import "~ekko-lightbox/dist/ekko-lightbox.css";

    [data-toggle="lightbox"][data-gallery="photo-gallery"] {
        .img-thumbnail {
            box-shadow: 0 0;
            transition: box-shadow .2s ease-in-out;
        }
        &:hover .img-thumbnail {
            box-shadow: 0 0 34px 4px rgba(255, 255, 255, 0.5);
        }
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/PhotoGallery.vue